import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ServiceAxios } from '../../../../services/ServiceEW';
import { ServiceValues } from '../../../../values/ServiceValues';
import {useStyles} from './InsumoRegisterInfoStyles'
import Alert from '@material-ui/lab/Alert';
import CurrencyTextField from '@unicef/material-ui-currency-textfield'



function InsumoRegisterInfo(props) {
  const {
    insumo,
    setInsumo,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    edicao
  } = props;
  const [openDialogFinish, setOpenDialogFinish] = React.useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [calibreSelecionado, setCalibreSelecionado] = useState("");
  const [refreshState, setRefreshState] = useState(new Date());
  const [calibres, setCalibres] = useState([]);
  const loadingCalibres = openAutocomplete && calibres.length === 0;
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();


  useEffect(() => {
    let active = true;
    if (!loadingCalibres) {
      return undefined;
    }
    (async () => {
      const params = {
        limit: 5000,
      };
      let dados = await api.get('calibres/', {params: params});
      dados = dados.data.result;
      if (active) {
        setCalibres(dados);
      }
    })();
    return () => {
      active = false;
    };
  }, [loadingCalibres]);


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };


  function modificarValores(order, value){
    switch (order) {
      case 0:
        insumo.descricao = value;
        break;
      case 1:
        insumo.quantidade = value;
        break;
      case 2:
        insumo.valorVenda = value;
        break;
    }
    setInsumo(insumo);
    setRefreshState(new Date());
  }

  return (
    <div>
      <CardHeader
        title="Insumo"
        subheader="Informe as seguintes informações da insumo"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Descrição"
              helperText="Insira a descrição do insumo."
              margin="dense"
              name="descricao"
              onChange={e => modificarValores(0, e.target.value)}
              value={insumo.descricao}
              variant="outlined"
              validators={['required', 'maxStringLength:155']}
              errorMessages={['Informe a descrição!', 'Descrição muito longa!']}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <CurrencyTextField
              label="Valor"
              helperText='Informe um valor para venda.'
              variant="outlined"
              value={insumo.valorVenda}
              currencySymbol="R$"
              minimumValue="0"
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator='.'
              fullWidth
              margin='dense'
              onChange={(event, value)=> modificarValores(2, value)}
            />
          </Grid>

          {!edicao &&
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Quantidade do insumo"
              helperText="Insira a quantidade inicial em estoque."
              margin="dense"
              name="quantidade"
              value={insumo.quantidade}
              onChange={e => modificarValores(1, e.target.value)}
              variant="outlined"
            />
          </Grid>
          }
        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

InsumoRegisterInfo.propTypes = {
  className: PropTypes.string,
  insumo: PropTypes.object.isRequired
};

export default InsumoRegisterInfo;


